export default class FileData {
    constructor(data) {
        this.fileName = data.fileName;
        this.filePath = data.filePath;
        this.contentType = data.contentType;
        this.transcription = data.transcription;
    }
}